/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
   const [theme, setTheme] = useState(() => localStorage.getItem('app-theme') || 'light');

   useEffect(() => {
      const applyTheme = t => {
         let activeTheme = t;
         if (t === 'system') {
            activeTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
         }
         document.body.classList.remove('light-body', 'dark-body');
         document.body.classList.add(`${activeTheme}-body`);
      };

      applyTheme(theme);
      localStorage.setItem('app-theme', theme);

      if (theme === 'system') {
         const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
         const handleChange = () => applyTheme('system');
         mediaQuery.addEventListener('change', handleChange);
         return () => mediaQuery.removeEventListener('change', handleChange);
      }
   }, [theme]);

   const value = useMemo(() => ({ theme, setTheme }), [theme]);

   return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => {
   const context = React.useContext(ThemeContext);
   if (!context) {
      throw new Error('useTheme must be used within a ThemeProvider');
   }
   return context;
};

ThemeProvider.propTypes = {
   children: PropTypes.node.isRequired,
};
